import type { NewsArticle, WithContext } from 'schema-dts';

import type { ShortnewsDetailFragment } from '#components/Shortnews/fragments/__generated__/ShortnewsDetail.generated';

import { defaultImage, publisher } from './constants';

export function buildContentPageStructuredData(
	shortnewsArticle: Omit<ShortnewsDetailFragment, '__typename' | 'trackingInfos'> & {
		trackingInfos: Omit<Pick<ShortnewsDetailFragment, 'trackingInfos'>, '__typename'> | Record<string, never>;
	},
	appUrl: string
): WithContext<NewsArticle> {
	return {
		'@context': 'https://schema.org',
		'@type': 'NewsArticle',
		author: publisher(appUrl),
		dateModified: shortnewsArticle.updateDate ?? undefined,
		datePublished: shortnewsArticle.updateDate ?? undefined,
		description: shortnewsArticle.text ?? undefined,
		headline: shortnewsArticle.title ?? undefined,
		mainEntityOfPage: shortnewsArticle.shareUrl ?? undefined,
		publisher: publisher(appUrl),
		url: shortnewsArticle.shareUrl ?? undefined,
		image: defaultImage(appUrl),
	};
}
